module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAApBAMAAACxeabGAAAAJFBMVEVHcEw+Slw+Slw9Rlk+Sl0/SV08SFw9SVs+SV0/SVw+SV0/Sl3qjcZNAAAAC3RSTlMAf9cV8LgqQpZcdTUTNC4AAADSSURBVCjPvdKvDoJQFAbwyxQuNngDNzcLhTkNzuLmpnMUm4FCpxhsFjuFRzDYLO5OnO57Of8g3HvhBCie+NvZt3PODgPA9PpIS3X1apvADFYth0nlrkOogWtjtTEntU+oSSaYuBPaxZPQGR6EHiAITQC/rh7g1NSCKAZW1MayGELRMTahqGmCXYxTRTmycjupo7dYgfA17YQ4MnbBQNPJdzETIlLU8rDIN1kresYtytOxLZUHGObzhVjJ3n32O0wvSKXytPiQaeVm9O800P/+OqkvCFNsmRbNjEIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutus/item_ren.png
// module id = cdzd
// module chunks = 18